import { formatThaiShortDateTwoDigitYear } from 'common/utils/date'
import { isSameDay } from 'date-fns'
import { useTranslation } from 'react-i18next'

export const dashboardDateDisplayValue = (startDate: Date | null, endDate: Date | null) => {
    const { t } = useTranslation(['farm', 'pond'])
  if (!startDate || !endDate) return t('farm:please.select.date')

  const now = new Date()
  const isDefault =
    startDate.toDateString() === now.toDateString() && endDate.toDateString() === now.toDateString()

  if (isDefault) return t('farm:please.select.date')

  return `${formatThaiShortDateTwoDigitYear(startDate)} - ${
    isSameDay(endDate, new Date()) ? t('pond:present') : formatThaiShortDateTwoDigitYear(endDate)
  }`
}
